import mitt from "mitt";

export const HowToModalController = function () {

    this.busModal = new mitt();

    //#region method
    this.show = function () {
        this.busModal.emit('show');
    };
    this.hide = function () {
        this.busModal.emit('hide');
    };
    //#endregion method
}

export default HowToModalController
